import React from "react";

const partnerLogos = [
  "https://upload.wikimedia.org/wikipedia/commons/4/44/Google-flutter-logo.svg",
  "https://upload.wikimedia.org/wikipedia/commons/0/02/Stack_Overflow_logo.svg",
  "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/google/google-original.svg",
  "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/apple/apple-original.svg",
  "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/facebook/facebook-original.svg",
  "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg",
  "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg",
  "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/linkedin/linkedin-original.svg",
];

export default function PartnerCarousel() {
  return (
    <div className="bg-white py-16 px-4 sm:px-6 lg:px-8 border-y border-gray-100">
      <div className="ca-container">
        {/* Section header */}
        <div className="text-center mb-10">
          <p className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-2">Trusted By</p>
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-800">
            Our Trusted <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">Partners</span>
          </h2>
        </div>
        
        {/* Carousel container */}
        <div className="relative overflow-hidden">
          {/* Fade edges */}
          <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-white to-transparent z-10"></div>
          <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-white to-transparent z-10"></div>
          
          {/* Scrolling logos */}
          <div className="flex animate-scroll whitespace-nowrap gap-16 items-center">
            {[...partnerLogos, ...partnerLogos].map((logo, index) => (
              <div key={index} className="flex-shrink-0 grayscale hover:grayscale-0 opacity-60 hover:opacity-100 transition-all duration-300">
                <img
                  src={logo}
                  alt={`Partner ${index}`}
                  className="h-10 sm:h-12 w-auto object-contain"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
